import config from '@project/config';
import { Guid } from '@project/types';

const baseUrl = `${config.apiUrl()}/Invoices`;
const baseReportsUrl = `${config.apiUrl()}/Reports/Invoices`;

export default {
  getInvoiceUrl: (id: Guid): string => `${baseUrl}/${id}`,
  getInvoicePaymentLinkUrl: (id: Guid): string => `${baseUrl}/${id}/create-payment-link`,
  getInvoicePrintTemplateUrl: (id: Guid): string =>
    `${baseUrl}/${id}/create-invoice-print-template`,
  getInvoiceTotalsContentUrl: (): string => `${baseReportsUrl}/Totals`,
  getIndividualPaidInvoicesUrl: (): string => `${baseUrl}/paid`,
  downloadInvoicePdfUrl: (invoiceId: Guid): string => `${baseUrl}/${invoiceId}/Content`,
};
